import './App.css';
import {LandingPage} from './views';

function App() {
  return (
    <div className="App">
      <LandingPage />
    </div>
  );
}

export default App;
